const WhiteLogo = () => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 661 151.4"
    xmlSpace="preserve"
  >
    <g>
      <path
        style={{ fill: "#f7f7f7ff" }}
        d="M146.5,106c-2-1.4-3.3-3.9-3.3-6.7c0-4.6,3.7-8.2,8.3-8.2c2.3,0,3.9,0.8,5.1,1.6c6.1,4.5,12.8,7.3,20.6,7.3
        c7.3,0,11.6-2.9,11.6-7.6v-0.2c0-4.5-2.8-6.8-16.2-10.2c-16.2-4.1-26.7-8.6-26.7-24.6v-0.2c0-14.6,11.7-24.3,28.2-24.3
        c9.8,0,18.3,2.5,25.6,7.1c2,1.2,3.9,3.6,3.9,7c0,4.6-3.7,8.2-8.3,8.2c-1.7,0-3.1-0.5-4.5-1.3c-5.9-3.5-11.4-5.4-16.9-5.4
        c-6.8,0-10.4,3.1-10.4,7v0.2c0,5.3,3.5,7,17.4,10.6c16.3,4.3,25.6,10.1,25.6,24.2v0.2c0,16-12.2,25-29.6,25
        C166.2,115.7,155.5,112.4,146.5,106z"
      />
      <path
        style={{ fill: "#f7f7f7ff" }}
        d="M210.9,84v-0.2c0-17.6,13.5-32.1,32.3-32.1c9.3,0,15.9,2.5,21.1,6.9c1.2,0.9,2.8,3,2.8,6
        c0,4.4-3.6,7.8-7.9,7.8c-2.3,0-4-0.9-5.1-1.7c-3.1-2.4-6.3-3.9-10.9-3.9c-8.7,0-15,7.7-15,16.8v0.2c0,9.4,6.1,17,15.7,17
        c4.6,0,8.2-1.6,11.5-4.3c0.9-0.7,2.6-1.6,4.7-1.6c4.1,0,7.4,3.3,7.4,7.5c0,2.3-1,4.1-2.5,5.5c-5.2,4.7-11.7,7.9-21.9,7.9
        C224.5,115.9,210.9,101.6,210.9,84z"
      />
      <path
        style={{ fill: "#f7f7f7ff" }}
        d="M273.6,60.9c0-4.8,3.9-8.7,8.7-8.7c4.8,0,8.7,3.9,8.7,8.7v2.8c2.5-6,6.7-11.5,11.9-11.5c5.4,0,8.5,3.6,8.5,8.5
        c0,4.6-3,7.4-6.6,8.2c-8.9,2.1-13.8,8.9-13.8,21.3v16.3c0,4.8-3.9,8.7-8.7,8.7c-4.8,0-8.7-3.9-8.7-8.7V60.9z"
      />
      <path
        style={{ fill: "#f7f7f7ff" }}
        d="M317.4,60.9c0-4.8,3.9-8.7,8.7-8.7s8.7,3.9,8.7,8.7v45.6c0,4.8-3.9,8.7-8.7,8.7s-8.7-3.9-8.7-8.7V60.9z"
      />
      <path
        style={{ fill: "#f7f7f7ff" }}
        d="M341.9,60.9c0-4.8,3.9-8.7,8.7-8.7c4.8,0,8.7,3.9,8.7,8.7v0.8c4.3-5.8,10.1-10,19.2-10
        c14.4,0,28.1,11.3,28.1,31.9v0.2c0,20.6-13.5,31.9-28.1,31.9c-9.3,0-15.1-4.3-19.2-9.2v14.9c0,4.8-3.9,8.7-8.7,8.7
        c-4.8,0-8.7-3.9-8.7-8.7V60.9z M389.2,83.8v-0.2c0-10.2-6.9-17-15.1-17c-8.2,0-15,6.8-15,17v0.2c0,10.2,6.8,17,15,17
        C382.3,100.8,389.2,94.1,389.2,83.8z"
      />
      <path
        style={{ fill: "#f7f7f7ff" }}
        d="M414.7,97V67.8h-0.6c-4.1,0-7.5-3.3-7.5-7.5c0-4.1,3.3-7.5,7.5-7.5h0.6v-7.7c0-4.8,3.9-8.7,8.7-8.7
        s8.7,3.9,8.7,8.7v7.7h7.7c4.1,0,7.5,3.3,7.5,7.5c0,4.1-3.3,7.5-7.5,7.5h-7.7v26.4c0,4,1.7,6,5.6,6c0.6,0,1.7-0.1,2.1-0.1
        c3.9,0,7.3,3.2,7.3,7.3c0,3.1-2.1,5.6-4.5,6.6c-3.2,1.3-6.2,1.7-10,1.7C421.9,115.5,414.7,111.3,414.7,97z"
      />
      <path
        style={{ fill: "#f7f7f7ff" }}
        d="M454.7,106c-2-1.4-3.3-3.9-3.3-6.7c0-4.6,3.7-8.2,8.3-8.2c2.3,0,3.9,0.8,5.1,1.6c6.1,4.5,12.8,7.3,20.6,7.3
        c7.3,0,11.6-2.9,11.6-7.6v-0.2c0-4.5-2.8-6.8-16.2-10.2c-16.2-4.1-26.7-8.6-26.7-24.6v-0.2c0-14.6,11.7-24.3,28.2-24.3
        c9.8,0,18.3,2.5,25.6,7.1c2,1.2,3.9,3.6,3.9,7c0,4.6-3.7,8.2-8.3,8.2c-1.7,0-3.1-0.5-4.5-1.3c-5.9-3.5-11.4-5.4-16.9-5.4
        c-6.8,0-10.4,3.1-10.4,7v0.2c0,5.3,3.5,7,17.4,10.6c16.3,4.3,25.6,10.1,25.6,24.2v0.2c0,16-12.2,25-29.6,25
        C474.3,115.7,463.6,112.4,454.7,106z"
      />
      <path
        style={{ fill: "#f7f7f7ff" }}
        d="M520.2,60.9c0-4.8,3.9-8.7,8.7-8.7s8.7,3.9,8.7,8.7v45.6c0,4.8-3.9,8.7-8.7,8.7s-8.7-3.9-8.7-8.7V60.9z"
      />
      <path
        style={{ fill: "#f7f7f7ff" }}
        d="M551.9,97V67.8h-0.6c-4.1,0-7.5-3.3-7.5-7.5c0-4.1,3.3-7.5,7.5-7.5h0.6v-7.7c0-4.8,3.9-8.7,8.7-8.7
        s8.7,3.9,8.7,8.7v7.7h7.7c4.1,0,7.5,3.3,7.5,7.5c0,4.1-3.3,7.5-7.5,7.5h-7.7v26.4c0,4,1.7,6,5.6,6c0.6,0,1.7-0.1,2.1-0.1
        c3.9,0,7.3,3.2,7.3,7.3c0,3.1-2.1,5.6-4.5,6.6c-3.2,1.3-6.2,1.7-10,1.7C559.2,115.5,551.9,111.3,551.9,97z"
      />
      <path
        style={{ fill: "#f7f7f7ff" }}
        d="M616.9,115.9c-18.5,0-32.2-13-32.2-31.9v-0.2c0-17.6,12.5-32.1,30.5-32.1c20.6,0,29.7,16.9,29.7,29.7
        c0,5.1-3.6,8.4-8.2,8.4H602c1.7,7.9,7.3,12.1,15.1,12.1c4.8,0,8.9-1.5,12.4-4.1c1.3-0.9,2.4-1.4,4.3-1.4c3.9,0,6.8,3,6.8,6.9
        c0,2.3-1,4-2.3,5.2C632.9,113,625.9,115.9,616.9,115.9z M628.2,78.8c-1-7.8-5.6-13.1-13-13.1c-7.3,0-12,5.2-13.4,13.1H628.2z"
      />
      <circle style={{ fill: "#f7f7f7ff" }} cx="326.1" cy="38.9" r="8.7" />
      <circle style={{ fill: "#f7f7f7ff" }} cx="529" cy="38.9" r="8.7" />
      <path
        style={{ fill: "#f7f7f7ff" }}
        d="M645.2,107.1c0-1.1,0.2-2.1,0.6-3.1c0.4-1,1-1.8,1.7-2.5c0.7-0.7,1.5-1.3,2.5-1.7c1-0.4,2-0.6,3.1-0.6
        c1.1,0,2.1,0.2,3.1,0.6c1,0.4,1.8,1,2.5,1.7c0.7,0.7,1.3,1.5,1.7,2.5c0.4,1,0.6,2,0.6,3.1c0,1.1-0.2,2.1-0.6,3.1
        c-0.4,1-1,1.8-1.7,2.5c-0.7,0.7-1.5,1.3-2.5,1.7c-1,0.4-2,0.6-3.1,0.6c-1.1,0-2.1-0.2-3.1-0.6c-1-0.4-1.8-1-2.5-1.7
        c-0.7-0.7-1.3-1.5-1.7-2.5C645.4,109.2,645.2,108.2,645.2,107.1z M646.6,107.1c0,0.9,0.2,1.7,0.5,2.5c0.3,0.8,0.8,1.5,1.4,2.1
        c0.6,0.6,1.3,1,2.1,1.4c0.8,0.3,1.6,0.5,2.5,0.5c0.9,0,1.7-0.2,2.5-0.5c0.8-0.3,1.5-0.8,2.1-1.4c0.6-0.6,1-1.3,1.4-2.1
        c0.3-0.8,0.5-1.6,0.5-2.5c0-0.9-0.2-1.7-0.5-2.5c-0.3-0.8-0.8-1.5-1.4-2.1c-0.6-0.6-1.3-1-2.1-1.4c-0.8-0.3-1.6-0.5-2.5-0.5
        c-0.9,0-1.7,0.2-2.5,0.5c-0.8,0.3-1.5,0.8-2.1,1.4c-0.6,0.6-1,1.3-1.4,2.1C646.8,105.4,646.6,106.2,646.6,107.1z M650.1,102.6h3.5
        c1.1,0,1.9,0.2,2.4,0.7c0.5,0.5,0.8,1.1,0.8,2c0,0.8-0.2,1.4-0.6,1.8c-0.4,0.4-0.9,0.6-1.5,0.7l2.3,3.8h-1.7l-2.2-3.7h-1.2v3.7
        h-1.7V102.6z M651.7,106.5h1.2c0.3,0,0.5,0,0.8,0c0.3,0,0.5-0.1,0.7-0.2c0.2-0.1,0.4-0.2,0.5-0.4c0.1-0.2,0.2-0.4,0.2-0.7
        c0-0.3-0.1-0.5-0.2-0.7c-0.1-0.2-0.3-0.3-0.5-0.4c-0.2-0.1-0.4-0.1-0.7-0.1c-0.3,0-0.5,0-0.8,0h-1.2V106.5z"
      />
      <path
//   className="st1"
  
        style={{ fill: "#ED2C24" }}
  d="M87.1,3.6C77.9-0.1,67.5-1,58.6,1.2c-10.8,2.6-19,9.4-23.2,19.2c-5.2,11.9-2.2,25.6,7.5,33.9
     c5.2,4.5,11.3,7,16.7,9.2c4.3,1.8,8.4,3.4,11.6,5.9c5.2,4.1,3.8,9.7,3.3,11.3c-1.3,3.7-4.7,7.7-10.5,7.7c-3.3,0-6.3-1.3-8.6-3.6
     s-3.6-5.4-3.6-8.6c0-4.4-3.6-8-8-8c-4.4,0-8,3.6-8,8c0,7.5,2.9,14.6,8.2,19.9c5.3,5.3,12.4,8.2,19.9,8.2c11.7,0,21.7-7.2,25.6-18.4
     c3.7-10.7,0.4-22.2-8.5-29.1c-4.9-3.8-10.5-6.1-15.4-8.1c-4.7-1.9-9.1-3.7-12.3-6.5c-4.5-3.9-5.7-9.9-3.3-15.6
     c5.6-13,22.1-12,31.1-8.3c15.4,6.2,27.4,22.2,29.8,39.8c0.7,5.3,0.6,10.6-0.4,15.8c-1.2,6.2-3.5,11.8-6.9,16.8
     c-3.4,4.9-7.6,9.2-11.4,12.9l-28.4,28.4L30,98.2c-15.3-15.3-18.5-39-7.7-57.7c1.1-1.8,1.3-4,0.8-6.1c-0.6-2.1-1.9-3.8-3.7-4.8
     c-1.2-0.7-2.6-1.1-4-1.1c-0.7,0-1.4,0.1-2.1,0.3c-2.1,0.6-3.8,1.9-4.8,3.7c-14.3,25-10.1,56.6,10.3,77l39.6,39.6
     c1.5,1.5,3.5,2.3,5.6,2.3c2.1,0,4.1-0.8,5.6-2.3l36-36c6.3-6.3,13.2-14,17.3-24.3c4.1-10.3,5.5-21.7,3.9-32.8
     C123.5,32.6,107.9,12,87.1,3.6z"
/>

    </g>
  </svg>
);

export default WhiteLogo;
